module.exports = __webpack_public_path__ + "media/images/writer/story_achievement_mailer/ogp_image_rank_no2-089ba2918dcf47daf196d73124209919.png";